<template>
    <div class="modal-login-overlay">

        <div class="modal-login">
            <RegisterScreen v-if="isRegister" @close="close" @acceptPolicy="acceptPolicy" />
            <div class="login-card" v-else>


                <button class="close-btn" @click="$emit('closeLoginModal')">×</button>

                <div class="text-center">
                    <img src="../assets/doc-icon-white.png" alt="App Logo" class="logo" />
                </div>

                <h2 class="modal-title">เข้าสู่ระบบ</h2>

                <p class="subtitle">เข้าสู่ระบบด้วยบัญชี Google ของคุณ</p>

                <button class="google-login-btn" @click="loginWithGoogle" :disabled="loading">
                    <img src="../assets/logo-google.png" alt="Google" class="google-icon" />
                    <span>เข้าสู่ระบบด้วย Google</span>
                </button>

                <div class="loading-container" v-if="loading">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { auth, googleProvider } from '@/firebase'
import { signInWithPopup } from 'firebase/auth'
import RegisterScreen from '../views/RegisterScreen'
export default {
    components: {
        RegisterScreen
    },
    data() {
        return {
            email: '',
            password: '',
            loading: false,
            isRegister: false
        };
    },
    methods: {
        close() {
            this.isRegister = false
            this.$router.push("/logout").then(() => {
                window.location.reload();
            });
            this.loading = false

        },
        async acceptPolicy() {
            const uid = this.$storex.getters.getUserData.uid
            const email = this.$storex.getters.getUserData.email
            const name = this.$storex.getters.getUserData.name


            await this.$http.post(`${process.env.VUE_APP_BACKEND_URL}/api/user/add`, { uid: uid, email: email, name: name, },)
            await this.$http.post(`${process.env.VUE_APP_BACKEND_URL}/api/creditWallet/add`, { uid: uid },)

            localStorage.setItem('aiModel', 'gemini-2.5-flash')

            localStorage.setItem('isRegister', 'found')

            this.$store.dispatch("setCredit", 0);

            this.$router.push("/").then(() => {
                window.location.reload();
            });
        },
        async loginWithGoogle() {

            try {
                this.loading = true

                const result = await signInWithPopup(auth, googleProvider)
                const user = result.user
                const idToken = await user.getIdToken()

                // ส่ง token ไป backend
                const access = await this.$http.post(`${process.env.VUE_APP_BACKEND_URL}/auth`, {
                    idToken,
                })

                const { displayName, email, uid } = user
                this.$store.dispatch('setUserData', { name: displayName, email, uid })
                this.$store.dispatch('setToken', access.data.jwtToken)

                const getUser = await this.$http.post(`${process.env.VUE_APP_BACKEND_URL}/api/user/`, { uid: uid, },)


                if (!getUser.data.status) {
                    this.isRegister = true
                    localStorage.setItem('isRegister', 'notfound')
                    localStorage.setItem('aiModel', 'gemini-2.5-flash')

                }

                else {
                    console.log('getUser', getUser)
                    localStorage.setItem('aiModel', getUser.data.data.aiModel)
                    // const history = await this.$http.post(`${process.env.VUE_APP_BACKEND_URL}/api/history/`, { uid: uid, token: access.data.jwtToken, },)
                    // this.$store.dispatch('setHistory', history.data.data)

                    this.$router.push("/").then(() => {
                        window.location.reload();
                    });
                }


            } catch (err) {
                this.loading = false
                alert(err.message)
            }
        },


        async handleLogin() {
            this.loading = true;
            try {
                // 👇 ทำการ login เช่น dispatch หรือ axios call
                await this.$store.dispatch('login', {
                    email: this.email,
                    password: this.password,
                });

                this.$store.commit('setShowLoginModal', false);
            } catch (err) {
                alert('เข้าสู่ระบบไม่สำเร็จ กรุณาตรวจสอบอีเมลและรหัสผ่าน');
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped>
.modal-login-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-login {
    background-color: #fff;
    padding: 2rem;
    border-radius: 1rem;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    width: 100%;
    max-width: 400px;
    max-height: 600px;
    position: relative;
}

.login-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
}

.logo {
    width: 28px;
    height: 28px;
    margin-bottom: 1rem;
    border-radius: 50%;
    background-color: var(--purple);
    padding: 2px;
}

.modal-title {
    font-size: 1.4rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
    text-align: center;
    color: #333;
}

.subtitle {
    font-size: 0.95rem;
    color: #666;
    margin-bottom: 1.5rem;
    text-align: center;
}

.google-login-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    border: 1px solid #ddd;
    padding: 0.75rem 1rem;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;
    width: 100%;
    transition: all 0.2s ease;
    font-size: 0.95rem;
}

.google-login-btn:hover {
    background: #f7f7f7;
}

.google-login-btn:disabled {
    opacity: 0.6;
    pointer-events: none;
}

.google-icon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
}

.close-btn {
    position: absolute;
    top: -10px;
    right: -10px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    font-size: 1.2rem;
    line-height: 1;
    text-align: center;
    cursor: pointer;
    color: #555;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.close-btn:hover {
    background-color: #f0f0f0;
}

.loading-container {
    margin-top: 1rem;
}
</style>
